import { useApi } from '@/api';
import { ExternalLink, Link, TableSkeleton } from '@/components';
import { TableColumn } from '@blockanalitica/ui/package/types/src/components/molecules/DataTable';

import {
  CurrencyValue,
  EtherScanPictogram,
  Flex,
  WalletAddress,
  DataTable,
  RelativeDateTime
} from '@blockanalitica/ui';

export default function FarmEventsTable({
  address,
  pagination,
  sorting,
  filters
}) {
  const [data, error] = useApi({
    url: `/farms/${address}/events/`,
    queryParams: {
      p: pagination.currentPage,
      p_size: pagination.pageSize,
      order: sorting.currentSorting,
      event: filters.filtersApplied.eventType
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    const columns: TableColumn[] = [
      {
        header: 'Wallet',
        getCell: (row) => (
          <Link to={`/rewards/${address}/suppliers/${row.wallet_address}`}>
            <WalletAddress
              address={row.wallet_address}
              options={{
                inline: true,
                sizes: { blockie: '0' }
              }}
            />
          </Link>
        ),
        columnSize: ['minmax(100px, auto)', 'minmax(150px, auto)']
      },
      {
        header: 'Event',
        getCell: (row) => row.event,
        headerAlign: 'flex-start'
      },
      {
        header: 'Amount',
        getCell: (row) => (
          <CurrencyValue
            value={row.amount}
            options={{
              trend: true,
              iconSize: '0',
              currency: {
                name:
                  row.event === 'RewardPaid'
                    ? row.rewards_token_symbol
                    : row.staking_token_symbol,
                address:
                  row.event === 'RewardPaid'
                    ? row.rewards_token_address
                    : row.staking_token_address
              }
            }}
          />
        ),
        sortingField: 'amount',
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      },
      {
        header: 'Time',
        getCell: (row) => (
          <Flex
            gap={['xs', '2xs']}
            color="muted"
            alignItems="center"
            justifyContent="center">
            <RelativeDateTime value={row.datetime} />
            <ExternalLink
              href={`https://etherscan.io/tx/${row.tx_hash}`}
              icon={<EtherScanPictogram size="0" />}
            />
          </Flex>
        ),
        sortingField: 'order_index',
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      }
    ];

    return (
      <DataTable
        rows={data['results']}
        columns={columns}
        getKey={(row) => row.order_index}
        sorting={sorting}
        pagination={{
          ...pagination,
          totalRecords: data.count
        }}
      />
    );
  }

  return <TableSkeleton />;
}
